import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import LogoFallback from "/assets/img/bubbanlogo.jpg";
import axios from "axios";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function LawPage({
  logoSrc = LogoFallback,
  accent = "#115e32",
  pageTitle = "Department of LAW | Bandarban University",
}) {
  // Update Browser Tab Title
  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const rootStyle = {
    "--accent": accent,
    backgroundImage: `linear-gradient(135deg, var(--accent) 0%, rgba(17,94,50,0.85) 40%, rgba(255,255,255,0.03) 100%)`,
  };

  return (
    <div>
      {/* Hero Section */}
		<section
        className="relative w-full overflow-hidden px-6 sm:px-8 lg:px-16"
        style={rootStyle}
		>
        <div className="relative max-w-7xl mx-auto flex flex-col items-center text-center py-20 lg:py-28">
          <img
            src={logoSrc}
            alt="Logo"
            className="w-28 h-28 object-contain drop-shadow-md mb-6"
          />

          <h1 className="text-4xl md:text-5xl font-bold text-white drop-shadow-lg">
            <span style={{ color: "var(--accent)" }}>Welcome to</span> Department of LAW
          </h1>

          <p className="mt-4 max-w-2xl text-white/90 text-lg sm:text-xl">
            Building bright minds with a strong foundation in knowledge,
            innovation, and community.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href={`${import.meta.env.VITE_API_SOURCE_URL}home/apply-online`}
              className="px-6 py-3 bg-white rounded-xl font-semibold text-sm shadow hover:opacity-95"
              style={{ color: "var(--accent)" }}
            >
              Apply Now
            </a>
            <a
              href="#about"
              className="px-6 py-3 border border-white/40 rounded-xl text-white text-sm hover:bg-white/10"
            >
              Learn More
            </a>
			</div>
		</div>
		
         {/* Decorative bottom wave */}
        <div className="-mt-6">
			<svg
				viewBox="0 0 1440 80"
				xmlns="http://www.w3.org/2000/svg"
				className="w-full h-20"
			>
            <path
              d="M0,32 C240,96 480,0 720,32 C960,64 1200,16 1440,32 L1440 80 L0 80 Z"
              fill="white"
              opacity="0.92"
            />
			</svg>
        </div>
		</section>
		 {/* Contact Info */}
		<section className="bg-gradient-to-r from-teal-600 to-green-600 text-white py-12">
        <div className="max-w-4xl mx-auto px-6 text-center space-y-4">
          <h3 className="text-2xl font-bold mb-4">Office of the Department of LAW</h3>
          <div className="flex flex-col md:flex-row justify-center gap-6">
            <div className="flex items-center gap-2">
              <MapPin size={20} /> <span>Rowadaw Heights Main Road, Bandarban town</span>
            </div>
            <div className="flex items-center gap-2">
              <Phone size={20} /> <span>+880 1318-305900</span>
            </div>
            <div className="flex items-center gap-2">
              <Mail size={20} /> <span>law@bubban.ac.bd</span>
            </div>
          </div>
          <button className="mt-6 px-6 py-3 bg-white text-teal-700 font-semibold rounded-lg shadow hover:bg-gray-100">
            Request Appointment
          </button>
        </div>
      </section>
	</div>
	);
}

LawPage.propTypes = {
  logoSrc: PropTypes.string,
  accent: PropTypes.string,
  pageTitle: PropTypes.string,
};

